import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white" }, "Company Statistics", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "card-p mt-n20 position-relative" }
const _hoisted_6 = { class: "row m-0" }
const _hoisted_7 = { class: "col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_8 = { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Companies ")
const _hoisted_10 = { class: "col bg-light-primary px-6 py-8 rounded-2 mb-7" }
const _hoisted_11 = { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Add New ")
const _hoisted_13 = { class: "row m-0" }
const _hoisted_14 = { class: "col bg-light-danger px-6 py-8 rounded-2 me-7" }
const _hoisted_15 = { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Declined ")
const _hoisted_17 = { class: "col bg-light-success px-6 py-8 rounded-2" }
const _hoisted_18 = { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Approved ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, _hoisted_3, 2),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_apexchart, {
        class: _normalizeClass([`bg-${_ctx.widgetColor}`, "mixed-widget-2-chart card-rounded-bottom"]),
        options: _ctx.chartOptions,
        series: _ctx.series,
        height: "200",
        type: "area"
      }, null, 8, ["class", "options", "series"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: { name: 'admin-companies' },
              class: "text-warning fw-bold fs-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
                ]),
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: { name: 'admin-companies-add' },
              class: "text-primary fw-bold fs-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: { name: 'admin-form-submission', params: { status: 'declined' } },
              class: "text-danger fw-bold fs-6 mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                ]),
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: { name: 'admin-form-submission', params: { status: 'approved' } },
              class: "text-success fw-bold fs-6 mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com010.svg" })
                ]),
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}